import { render } from "./FooterContainer.vue?vue&type=template&id=430c0b05&scoped=true"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"

import "./FooterContainer.vue?vue&type=style&index=0&id=430c0b05&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430c0b05"]])

export default __exports__